import { render, staticRenderFns } from "./train.vue?vue&type=template&id=0e39fa44&scoped=true"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"
import style0 from "./train.vue?vue&type=style&index=0&id=0e39fa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e39fa44",
  null
  
)

export default component.exports